import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/mdn-logo-text.png'



export default /*#__PURE__*/_defineComponent({
  __name: 'MadarionLogo',
  props: {
    dark: { type: Boolean, default: true }
  },
  setup(__props: any) {

// defineProps and withDefaults are compiler macros; this project's ESLint config predates them.
// eslint-disable-next-line no-undef


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: _imports_0,
    alt: "Madarion",
    width: "530",
    height: "104",
    class: _normalizeClass(['madarion-logo', { 'on-dark': _ctx.dark }])
  }, null, 2))
}
}

})